import {Notation} from 'biojs/BioConstants';
import {RegistryLabelingStrategy} from 'constants/RegistryConstants';
import {ImplementedStaticSchemaInterfaceGQL} from 'notebook/structured-tables/components/modals/RegistrationTableInsertModal';
import {StructuredTableFolderOption} from 'notebook/structured-tables/components/useSelectFolderOptionForTable';
import {RowMetadata} from 'notebook/tables/TableConstants';

/**
 * This enum specifies which type of Registration table we are inserting.  A Registration table can either:
 * - create new entities which haven't been created before.  The name column is not available in these cases
 *   and is determined by the labeling strategy.
 * - register existing entities
 * - register batches: this is a legacy mode for creating batches which is only supported using the
 *   LegacyRegistrationTable
 *
 * The values of the enum are used as the actual labels for the buttons in the insertion modal.
 *
 * This enum should be kept in sync with benchling/notebook/structured_tables/registration_tables.py
 */
export enum RegistrationTableInsertType {
  CREATE_NEW_ENTITIES = 'Create new entities',
  REGISTER_EXISTING_ENTITIES = 'Register existing entities',
  LEGACY_REGISTER_BATCHES = 'Register batches',
}

export interface RegistrationStructuredTableMetadata {
  insertType: RegistrationTableInsertType;
  labelingStrategy: RegistryLabelingStrategy;
  implementedSchemaInterfaces?: Array<ImplementedStaticSchemaInterfaceGQL>;
  notation?: Notation | null;
  customSyntaxName?: string | null;
  folderOption?: StructuredTableFolderOption;
  /* If folderOption is SPECIFY_FOLDER, then folderId designates the selected folder to create items in.
   * Otherwise it will be undefined. */
  folderId?: string;
}

export interface RegistrationStructuredTableRowMetadata extends RowMetadata {}
